/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    document.querySelector("#miniCart").showModal()

    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // When change product is triggered we already receive updated cart so don't download
    if (!skipFetch) {
        // fetch cart
        cart = await fetch("/cart.js")
            .then(data => data.json());
    }

    // remove free gifts
    const itemsToRemove = cart.items.filter(item => item.properties?._gift);
    if (itemsToRemove.length > 0) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        itemsToRemove.forEach(item => {
            updatePayload[item.key] = 0;
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    // Update Cart Counter On Header
    if (cart.item_count === 0) {
        document.querySelector("#headerCart").classList.remove("count");
        document.querySelector("#headerCart").removeAttribute("count")
    } else {
        document.querySelector("#headerCart").classList.add("count");
        document.querySelector("#headerCart").setAttribute("count", cart.item_count)
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    if (document.querySelector("#miniCartFooterUpsell")) {
        document.querySelector("#miniCartFooterUpsell").classList.add("active");
    }
    document.querySelector("#miniCartFooter").classList.add("active");

    // Free shipping for price threshold
    let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
    if (cart.total_price >= freeShippingThreshold) {
        document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
        document.querySelector("#miniCartHeaderBarInner").classList.add("active");
    } else if (cart.total_price === 0) {
        document.querySelector("#miniCartHeaderShipping").innerHTML = `Your cart is Empty. Add ${price(freeShippingThreshold)} or more for FREE shipping.`;
        document.querySelector("#miniCartHeaderBarInner").style.width = `0`;
        document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
    } else {
        document.querySelector("#miniCartHeaderShipping").innerHTML = `${price(freeShippingThreshold - cart.total_price)} away from free shipping`;
        document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
        document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
    }
    // check free gift threshold
    cart.total_price >= parseInt(cartSettings.free_gift_threshold * 100)
        ? document.querySelector("#miniCartHeaderGift").classList.add("active")
        : document.querySelector("#miniCartHeaderGift").classList.remove("active");

    // determine which gifts to show
    document.querySelectorAll(".miniCartBodyItem.gift").forEach(element => {
        const minThreshold = parseInt(element.dataset.min);
        const maxThreshold = parseInt(element.dataset.max);

        // if cart.original_total_price is between min and max threshold, show gift
        if (cart.original_total_price >= minThreshold && cart.original_total_price <= maxThreshold) {
            element.classList.add("active");
        } else {
            element.classList.remove("active");
        }
    });

    // reset container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(element => element.remove());

    // calculate compare at price
    let totalComparePrice = 0;
    cart.items.forEach(function (item) {
        if (variantToComparePrice[item.variant_id]) {
            totalComparePrice += variantToComparePrice[item.variant_id] * item.quantity;
        }
    });

    // update subtotal
    console.log(cart);
    if (totalComparePrice > cart.total_price) {
        document.querySelector("#miniCartFooterCheckoutTotal").innerHTML = `<s>${price(totalComparePrice, false)}</s> ${price(cart.total_price, false)}`
    } else if (cart.original_total_price > cart.total_price) {
        document.querySelector("#miniCartFooterCheckoutTotal").innerHTML = `<s>${price(cart.original_total_price, false)}</s> ${price(cart.total_price, false)}`
    } else {
        document.querySelector("#miniCartFooterCheckoutTotal").textContent = price(cart.total_price, false);
    }

    // append cart
    cart.items.forEach(function (item) {

        // discount html
        function discountHTML() {
            // if there are no line level discounts we exit
            if (item.line_level_discount_allocations.length === 0) {
                return ""
            }

            // loop through line level discounts
            let HTML = `<div class="miniCartBodyItemDiscount">`;
            item.line_level_discount_allocations.forEach(function (discount) {
                HTML += `<span class="miniCartBodyItemDiscountItem">${discount.discount_application.title}</span>`
            });
            HTML += `</div>`;

            return HTML;
        }

        // subscription html
        function subscriptionHTML() {
            // if there are no selling plans we exit
            if (!variantToCadence[item.variant_id]) {
                return ""
            }

            //  check if plan added
            let hasPlan = false;

            // create plan options
            let options = ``;

            let cadenceLookup = cadenceToPlan;
            if (item.handle === "sweat-control-trio") {
                cadenceLookup = trioCadenceToPlan;
            }

            for (let cadence in cadenceLookup) {
                // 3-step-system-90-day-supply only has 90 days option
                if (item.handle === "3-step-system-90-day-supply" && cadence !== "90") {
                    continue;
                }

                // determine the correct verbiage, by default we assume months
                let label = `Every ${Math.round(cadence / 30)} month${cadence === "30" ? "" : "s"}`;
                if (cadence === "45") {
                    label = `Every 45 days`;
                }

                // mark as having plan
                if (cadenceToPlan[cadence] === item.selling_plan_allocation?.selling_plan.id) {
                    hasPlan = true;
                }

                options += `<button class="miniCartBodyItemSubscriptionSelectionOptionsItem ${cadenceToPlan[cadence] === item.selling_plan_allocation?.selling_plan.id ? "active" : ""}" 
                                data-id="${cadenceToPlan[cadence]}" aria-label="select plan">${label}</button>`
            }

            let title = item.selling_plan_allocation ? item.selling_plan_allocation?.selling_plan.name : "One time";
            title = title === "Every 30 days" ? "Every 1 month" : title;

            return `
                        <div class="miniCartBodyItemSubscription" data-variant="${item.variant_id}">
                            <button class="miniCartBodyItemSubscriptionButton" 
                                aria-label="Select/add plan" aria-expanded="false" aria-controls="${item.variant_id}">${title}</button>
                            <div class="miniCartBodyItemSubscriptionSelection" id="${item.variant_id}">
                                <button class="miniCartBodyItemSubscriptionSelectionTitle ${!hasPlan ? "active" : ""}" 
                                data-id="otp" aria-label="no subsription">One time</button>
                                <div class="miniCartBodyItemSubscriptionSelectionOptions">
                                    <div class="miniCartBodyItemSubscriptionSelectionOptionsTitle">Auto-delivery</div>
                                    ${options}
                                </div>
                            </div>
                        </div>                  
                `;
        }

        function priceHTML() {
            let html = price(item.final_line_price, false);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (variantToComparePrice[item.variant_id]) {
                comparePrices.push(variantToComparePrice[item.variant_id] * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    html += ` <s>${price(greatestComparePrice, false)}</s>`;
                }
            }

            return html;
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <a class="miniCartBodyItemLink" href="${item.url}">
                    <img class="miniCartBodyItemLinkImage" src="${item.image}&width=200" alt="${item.product_title}">
                </a>
                <div class="miniCartBodyItemColumn">
                    <a class="miniCartBodyItemTitle" href="${item.url}">${item.product_title}</a>
                    <div class="miniCartBodyItemVariant">${item.variant_title ?? ""}</div>
                    ${discountHTML()}
                    <div class="miniCartBodyItemColumnBottom">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus" title="remove one">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus" title="add one">+</button>
                        </div>
                        ${subscriptionHTML()}    
                    </div>
                </div>
                <div class="miniCartBodyItemColumn">
                    <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    <button class="miniCartBodyItemRemove" aria-label="remove item">
                       <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5604 16.3923H11.5061C11.6315 16.3923 11.7518 16.3425 11.8405 16.2538C11.9292 16.1651 11.979 16.0448 11.979 15.9194V7.40806C11.979 7.28265 11.9292 7.16237 11.8405 7.0737C11.7518 6.98502 11.6315 6.9352 11.5061 6.9352H10.5604C10.435 6.9352 10.3147 6.98502 10.2261 7.0737C10.1374 7.16237 10.0876 7.28265 10.0876 7.40806V15.9194C10.0876 16.0448 10.1374 16.1651 10.2261 16.2538C10.3147 16.3425 10.435 16.3923 10.5604 16.3923ZM17.0228 3.15236H13.7754L12.4357 0.918126C12.2675 0.637966 12.0297 0.406139 11.7453 0.245237C11.461 0.0843346 11.1397 -0.000155388 10.813 2.14536e-07H6.84024C6.51363 -1.92597e-05 6.19258 0.0845354 5.90836 0.245431C5.62413 0.406327 5.38641 0.63808 5.21834 0.918126L3.8778 3.15236H0.630473C0.463261 3.15236 0.302898 3.21879 0.184661 3.33703C0.0664246 3.45526 0 3.61563 0 3.78284L0 4.41331C0 4.58052 0.0664246 4.74089 0.184661 4.85912C0.302898 4.97736 0.463261 5.04378 0.630473 5.04378H1.26095V18.2837C1.26095 18.7853 1.46022 19.2664 1.81493 19.6211C2.16964 19.9759 2.65073 20.1751 3.15236 20.1751H14.5009C15.0025 20.1751 15.4836 19.9759 15.8383 19.6211C16.193 19.2664 16.3923 18.7853 16.3923 18.2837V5.04378H17.0228C17.19 5.04378 17.3503 4.97736 17.4686 4.85912C17.5868 4.74089 17.6532 4.58052 17.6532 4.41331V3.78284C17.6532 3.61563 17.5868 3.45526 17.4686 3.33703C17.3503 3.21879 17.19 3.15236 17.0228 3.15236ZM6.77128 2.00609C6.79235 1.97101 6.82216 1.94201 6.8578 1.92191C6.89344 1.90181 6.93369 1.8913 6.97461 1.89142H10.6786C10.7195 1.89137 10.7596 1.90191 10.7952 1.92201C10.8308 1.9421 10.8605 1.97107 10.8816 2.00609L11.5696 3.15236H6.08367L6.77128 2.00609ZM14.5009 18.2837H3.15236V5.04378H14.5009V18.2837ZM6.14711 16.3923H7.09282C7.21823 16.3923 7.3385 16.3425 7.42718 16.2538C7.51586 16.1651 7.56567 16.0448 7.56567 15.9194V7.40806C7.56567 7.28265 7.51586 7.16237 7.42718 7.0737C7.3385 6.98502 7.21823 6.9352 7.09282 6.9352H6.14711C6.0217 6.9352 5.90143 6.98502 5.81275 7.0737C5.72407 7.16237 5.67426 7.28265 5.67426 7.40806V15.9194C5.67426 16.0448 5.72407 16.1651 5.81275 16.2538C5.90143 16.3425 6.0217 16.3923 6.14711 16.3923Z" fill="black"/>
                       </svg>
                    </button>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem:not(.gift)`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItemQuantity();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItemQuantity();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItemQuantity();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // open update list
        element.querySelector('.miniCartBodyItemSubscriptionButton')?.addEventListener("click", function () {
            this.classList.contains("active") ? this.setAttribute("aria-expanded", "false") : this.setAttribute("aria-expanded", "true");
            this.classList.toggle("active");
        })

        // update quantity function
        async function updateCartItemQuantity() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // change subscription status
        element.querySelectorAll(".miniCartBodyItemSubscriptionSelectionOptionsItem,.miniCartBodyItemSubscriptionSelectionTitle")?.forEach(item => {
            item.addEventListener("click", async function () {
                // acive class it plan, or lack thereof
                if (this.classList.contains("active")) return;
                this.classList.add("loading");

                // change subscription
                cart = await changeProduct({
                    id: key,
                    selling_plan: this.dataset.id === "otp" ? "" : this.dataset.id
                });

                // update active body
                await openCart(true);
            });
        })
    });

    // check if cart contains an upsell item
    // start a count, only 2 can be shown at a time
    let shownItems = 0;
    document.querySelectorAll(".miniCartFooterUpsellListItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart || shownItems >= 2) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
            shownItems++;

            // fire impression once per page load when the item is first shown
            if (!element.dataset.impressionFired) {
                Shopify.analytics.publish("upsell_impression", {
                    widget: "cart",
                    upsell: {
                        product_id: element.dataset.product,
                        variant_id: element.dataset.variantId,
                        product_title: element.dataset.productTitle,
                        variant_title: element.dataset.variantTitle,
                    },
                });
                element.dataset.impressionFired = "1";
            }
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartFooterUpsellListItem.active")?.length === 0 && document.querySelector("#miniCartFooterUpsell")) {
        document.querySelector("#miniCartFooterUpsell").classList.remove("active");
    }
    document.querySelector("#miniCart").focus();
}

// upsell items
document.querySelectorAll('.miniCartFooterUpsellListItemButton')?.forEach(el => {
    el.addEventListener("click", async function () {

        // if not id return
        if (!this.dataset.id) return;

        // pull context from the wrapping item for the analytics payload
        const item = this.closest('.miniCartFooterUpsellListItem');

        // track the click before adding (so the event fires even if /cart/add.js is slow)
        Shopify.analytics.publish("upsell_atc_click", {
            widget: "cart",
            upsell: {
                product_id: item.dataset.product,
                variant_id: item.dataset.variantId,
                product_title: item.dataset.productTitle,
                variant_title: item.dataset.variantTitle,
            },
        });

        // add loading and the product, with line item properties attributing it to this widget
        this.classList.add("loading");

        await addProduct({
            id: this.dataset.id,
            quantity: 1,
            properties: {
                "_upsell_widget": "cart",
            },
        });

        this.classList.remove("loading");

        // update active body
        await openCart();
    })
})

// upsell detail click - when the user clicks the image link to view the upsell's PDP
document.querySelectorAll('.miniCartFooterUpsellListItemLink').forEach(el => {
    el.addEventListener("click", function () {
        const item = this.closest('.miniCartFooterUpsellListItem');
        if (!item) {
            return;
        }
        // natural navigation continues - the pixel uses keepalive: true so the fetch survives
        Shopify.analytics.publish("upsell_detail_click", {
            widget: "cart",
            upsell: {
                product_id: item.dataset.product,
                variant_id: item.dataset.variantId,
                product_title: item.dataset.productTitle,
                variant_title: item.dataset.variantTitle,
            },
        });
    });
});

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart function
function closeCart() {
    //ADD THE VANISH ANIMATION
    document.querySelector("#miniCart").classList.add("vanish");
    //LISTEN FOR  THE ANIMATION END AND CLOSE THE DIALOG
    document.querySelector("#miniCart").addEventListener("animationend", (event) => {
        const cartEl = document.querySelector("#miniCart");
        if (cartEl.classList.contains("vanish")) {
            cartEl.classList.remove("vanish");
            cartEl.close();
        }
    });

}

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

// close listener
document.querySelector("#miniCart").addEventListener("close", () => document.querySelector("body").classList.remove("noScroll"));

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");


    // stop loading
    this.classList.remove("loading");

    // close the minicart
    closeCart();

    // open upgrade modal
    setTimeout(async () => {
        await openUpgrade();
    }, 200)

});

/***********************************************88 Upgrade *********************************************/

// open upgrade
async function openUpgrade() {
    // the popup only run if there are one-time products that can be upgrade
    redirectCheckout = true;
    document.querySelector("#upgradeWrap").classList.add("active");

    // determine how many upgradeable products there are that can be upgraded to a subscription
    let upgradeableProducts = cart.items.filter(function (item) {
        // check if this product offers subscriptions
        let upgradeable = false;

        // that must not already have a selling plan
        if (item.selling_plan_allocation !== undefined) {
            return false;
        }

        // check if this product has a selling plan
        if (variantToCadence[item.variant_id]) {
            upgradeable = true;
        }

        return upgradeable;
    });

    // check if there are no upgradeable products
    if (upgradeableProducts.length === 0) {
        // close popup
        await closeUpgrade();

        // exit
        return;
    }

    // calculate upgrade savings
    let savings = 0;
    upgradeableProducts.forEach(function (item) {
        savings += item.original_line_price * 0.15;
    })

    // save 15% off
    document.querySelector("#upgradeATC").textContent = `SAVE - ${price(savings)}`

    document.querySelector("body").classList.add("noScroll");
    document.querySelector("#upgrade").showModal();

}

let redirectCheckout = true;

// close upgrade
async function closeUpgrade() {
    // close popup
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector("#upgrade").close();

    if (!redirectCheckout) {
        return;
    }

    // show redirecting
    document.querySelector('#checkoutRedirecting').classList.add('active');

    // remove free gifts
    const itemsToRemove = cart.items.filter(item => item.properties?._gift);
    if (itemsToRemove.length > 0) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        itemsToRemove.forEach(item => {
            updatePayload[item.key] = 0;
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
        }
    }

    // add free gifts
    for (const gift of cartGifts) {
        // if cart.original_total_price is between min and max threshold, add gift
        if (cart.original_total_price >= gift.min && cart.original_total_price <= gift.max) {
            await addProduct({
                id: gift.variant,
                quantity: 1,
                properties: {
                    "_gift": true
                }
            });
        }
    }

    // redirect to checkout
    window.location.href = "/checkout";
}

// close events
document.querySelector("#upgrade").addEventListener("click", function (e) {
    if (e.target === this) {
        closeUpgrade().catch(err => console.log(err));
    }
});
document.querySelector("#upgrade").addEventListener("close", function () {
    closeUpgrade().catch(err => console.log(err));
});
document.querySelector("#upgradeNo").addEventListener("click", function () {
    closeUpgrade().catch(err => console.log(err));
});
document.querySelector("#upgradeClose").addEventListener("click", function () {
    closeUpgrade().catch(err => console.log(err));
});

// upgrade event listener
document.querySelector("#upgradeATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // upgrade each product
    for (let i = 0; i < cart.items.length; i++) {
        if (variantToCadence[cart.items[i].variant_id]) {
            await changeProduct({
                id: cart.items[i].key,
                quantity: cart.items[i].quantity,
                selling_plan: cadenceToPlan[variantToCadence[cart.items[i].variant_id]],
                properties: {
                    "_upgrade": true
                }
            });
        }
    }

    // close
    await closeUpgrade();

    // stop loading animation
    this.classList.remove("loading");
});

document.addEventListener("cart:refresh", (e) => {
    if (!document.querySelector("#miniCart").open) return;
    if (e.detail?.cart) cart = e.detail.cart;
    openCart();
});
